module.exports = __webpack_public_path__ + "img/pic6.195f48ca.png";